//import Head from 'next/head';

import React from 'react';
import {
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { auth, db } from '../../firebase';
import Tablero from './Tablero';
import Micuenta from './micuenta';
import Mensaje from './Mensaje';
import Soporte from './Soporte'
import Express from './Express';
import FadeInOut from '../../components/animations/FadeInOut';

import Direcciones from './Direcciones';
import AddUser from './AddUser';
import Companies from './Companies';
import BranchOffc from './BranchOffc';
import Administrators from './Administrators';
import Users from './Users';
import Maps from './Maps';
import Drivers from './Drivers';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import Dispatchs from './Dispatchs';
import Guias from './Guias';
import Rutas from './Rutas';
import Serviciosdash from './Serviciosdash';
import Configuraciones from './Configuraciones';
import Seguridad from './Seguridad';
import ReportBug from './ReportBug';
import BlockInterface from './BlockInterface';
import Seleccioneplan from './Serviciosdash/Seleccioneplan'
import Billing from "../Dashboard/Billing/Billing"

import { Grid } from 'semantic-ui-react';

import { DashboardSidebar } from '../../components/Dashboard/DashboardSidebar';
import { DashboardSidebarCliente} from '../../components/Dashboard/DashboardSidebarCliente';
import { DashboardSidebarAdminCompany} from '../../components/Dashboard/DashboardSidebarAdminCompany';

import { DashboardNavbar } from '../../components/Dashboard/DashboardNavbar';
import { useSelector} from 'react-redux'
import Dispatchdetails from '../../components/Dispatchdetails';
import useTitle from '../../components/Seo/useTitle';
import useGlobalConfig from '../../hooks/globalConfig';
import Seleccionepack from './Serviciosdash/Seleccionepack';
import DashDispatchs from '../../components/ManagementRoutes/DashDispatchs/DashDispatchs';
import DashDispatchsEdit from '../../components/ManagementRoutes/DashDispatchs/DashDispatchsEdit/DashDispatchsEdit';
import DashDispatchsNew from '../../components/ManagementRoutes/DashDispatchs/DashDispatchsNew/DashDispatchsNew';
import DashDispatchsAdd from '../../components/ManagementRoutes/DashDispatchs/DashDispatchsAdd/DashDispatchsAdd';
import DashRoutes from '../../components/ManagementRoutes/DashRoutes/DashRoutes';
import DashRoutesEdit from '../../components/ManagementRoutes/DashRoutes/DashRoutesEdit/DashRoutesEdit';
import DashRoutesNew from '../../components/ManagementRoutes/DashRoutes/DashRoutesNew/DashRoutesNew';
import DashRoutesAdd from '../../components/ManagementRoutes/DashRoutes/DashRoutesAdd/DashRoutesAdd';
import Vehicles from './Vehicles/Vehicles';
import Fleet from './Fleet/Fleet';


const Dashboard = (props , ...rest) => {
  const {siteName} = useGlobalConfig()
  useTitle({title:`${siteName} Dashboard`})

  
        const actualUserRoll = useSelector(store => store.usuario.user.roll)
        const[userRoll,setUserRoll] = React.useState('public');
        const[userCompanyRoll,setUserCompanyRoll] = React.useState('');
        const[userPermissions,setUserPermissions] = React.useState(null);
        const userUid = useSelector(store => store.usuario.user.uid);
        const [showoggleMenu, setShowoggleMenu] = React.useState(true);
        const toggleMenu = () => setShowoggleMenu(!showoggleMenu);

      const RutaPotegida = ({component, path,keyid,userUid, ...rest}) => {
       
       // // console.log('ruta Protegida')
       // // console.log(userUid) 

        const [user,setUser] = React.useState(()=>{ if(auth.currentUser){
                                                        return auth.currentUser
                                                        }else{
                                                          // console.log('Se cerro session')
                                                          return <Redirect to="/" {...rest} />
                                                        }
                                                      })

         React.useEffect (() => {
          const fetchUser = () => {
            auth.onAuthStateChanged(user => {
               // // console.log(user)
                if(user){
                    setUser(user)}
                // else{
                //     setUser(null)
                // }
            })
          }
          fetchUser()
        }, [])

        React.useEffect (() => {},[,actualUserRoll ,userCompanyRoll, userRoll])
        
      
        if(!user.uid){
          return <Redirect to="/login" {...rest} />
        }

        if(localStorage.getItem('usuario')){
          const usuarioStorage = JSON.parse(localStorage.getItem('usuario'))
          
          const usuarioLocal = usuarioStorage.uid;
          //console.log(usuarioStorage)
          const obtenerRollUsuario = async (id ) => {
                      try {
                        const user = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
                        .doc(id)
                        .get();
                         //console.log(user.data())

                        setUserRoll(user.data().roll)

                        setUserCompanyRoll(user.data().userCompanyRoll)

                        } catch (error) {
                          // console.log(error)            
                        }
                      }
          obtenerRollUsuario(user.uid);
          const obtenerServicios = async (userRoll,userCompanyRoll, keyid) => {
                      try {
                        const servicio = await db.collection(`${process.env.REACT_APP_COL_ROLES}`) 
                        .doc(userRoll)
                        .get();
                        

                        const servicioComp = await db.collection(`${process.env.REACT_APP_COL_ROLES}`) 
                        .doc(userCompanyRoll)
                        .get();

                        //console.log(servicio.data()[keyid])
                        if(servicio.data()[keyid] === true){
                          //console.log(servicio.data()[keyid])
                          setUserPermissions(servicio.data()[keyid])
                          return
                        }
                        //console.log(servicioComp.data()[keyid])
                        if(servicioComp.data()[keyid] === true){
                          //console.log(servicioComp.data()[keyid])
                          setUserPermissions(servicioComp.data()[keyid])
                          return
                        }

                        setUserPermissions(servicio.data()[keyid])

                      } catch (error) {
                        setUserPermissions(null)

                      }
                    }
          obtenerServicios(userRoll,userCompanyRoll, keyid)

    
          if( usuarioLocal === user.uid ){
           // console.log(userPermissions)
           if(userPermissions === true ) {
            return <Route component={component} usuarioLocal={usuarioLocal} props={props} path={path} {...rest} />
            }else{ return <BlockInterface usuarioLocal={usuarioLocal} permissions={userPermissions} component={BlockInterface} path={path} {...rest} />
            }
            }else{ return <Redirect to="/login" {...rest} />}
             }else{ return <Redirect to="/login" {...rest} /> }
          

            
      }

      const sidebarAdmin = (rol , userRoll, userCompanyRoll) => {
        // console.log(rol)
        // console.log(userRoll)
        // console.log(userCompanyRoll)

        if(rol === process.env.REACT_APP_ADMIN ){return <DashboardSidebar />}
        if(rol === process.env.REACT_APP_ADMIN_XPRESS ){return  <DashboardSidebar />}
        if(userRoll === process.env.REACT_APP_CLIENT ){
          if(userCompanyRoll === process.env.REACT_APP_ADMIN_COMPANY ){
            return <DashboardSidebarAdminCompany />}
            return <DashboardSidebarCliente />

          }
        
      }
 //OBTENER DIRECTORIO PADRE
  return(
   <div className='testcomponenbody'>

      <Grid celled='internally'>
       <Grid.Row className='DashboardNavbarrow'>
       <Grid.Column computer={16} mobile={16} tablet={16}   className='testcomponenbodynav'>
       <FadeInOut show={showoggleMenu} duration={500}> 
       <DashboardNavbar/>
       </FadeInOut>
       <div id='btntogglemenucont'>
       <button  className="btn"  onClick={toggleMenu}>
         {
           showoggleMenu?(<><VisibilityOff></VisibilityOff> Ocultar opciones</>):(<><Visibility></Visibility> Ver Opciones</>)
         }
         </button>
       </div>   
       </Grid.Column>
       </Grid.Row>
       <Grid.Row>

      
       <Grid.Column computer={2} mobile={16} tablet={8}  id="testScroll1"  className='testcomponensidebar'>
       <FadeInOut show={showoggleMenu} duration={500}> 
        {
        sidebarAdmin(actualUserRoll, userRoll, userCompanyRoll )
        }
        </FadeInOut>
       </Grid.Column>
       <Grid.Column computer={13} mobile={16} tablet={8}  id="testScroll2"  className='testcomponen'>
       <Grid.Row id="dash-container">
       <Grid.Column width={16} className="dash-container-colmun" >
        <Switch>
          <Route  component={Tablero} path="/dashboard" {...rest} exact/>
      
          <RutaPotegida keyid="serv01" userUid component={Tablero} path="/dashboard/tablero" exact/>
          <RutaPotegida keyid="serv02" userUid component={Express} path="/dashboard/envios-express" exact/>

          <RutaPotegida keyid="serv03" userUid component={Micuenta} path="/dashboard/mi-cuenta" exact/>

          <RutaPotegida keyid="serv04" userUid component={Direcciones} path="/dashboard/direcciones" exact/>
          
          <RutaPotegida keyid="serv09" userUid component={Companies} path="/dashboard/companies" exact/>
          <RutaPotegida keyid="serv11" userUid component={AddUser} path="/dashboard/usuarios" exact/>
          
          <RutaPotegida keyid="serv10" userUid component={BranchOffc} path="/dashboard/stores" exact/>

          <RutaPotegida keyid="serv12" userUid component={Administrators} path="/dashboard/administrators" exact/>
          <RutaPotegida keyid="serv13" userUid component={Users} path="/dashboard/users" exact/>

          <RutaPotegida keyid="serv05" userUid component={Maps} path="/dashboard/maps" exact/>
          <RutaPotegida keyid="serv16" userUid component={Drivers} path="/dashboard/drivers" exact/>
          <RutaPotegida keyid="serv16" userUid component={Vehicles} path="/dashboard/vehicles" exact/>
    
          <RutaPotegida keyid="serv14" userUid component={Dispatchs} path="/dashboard/creartedispatch" exact/>
          <RutaPotegida keyid="serv15" userUid component={Fleet} path="/dashboard/fleet" exact/>
          <RutaPotegida keyid="serv15" userUid component={Dispatchs} path="/dashboard/dispatch" exact/>
          <RutaPotegida keyid="serv15" userUid component={Dispatchdetails} path="/dashboard/dispatch/details/:id" exact/>


          <RutaPotegida keyid="serv15" userUid component={Guias} path="/dashboard/guias" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashDispatchs} path="/dashboard/guias/details/:id" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashDispatchsEdit} path="/dashboard/guias/:id/edit" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashDispatchsNew} path="/dashboard/guias/new" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashDispatchsAdd} path="/dashboard/guias/add" exact/>


          <RutaPotegida keyid="serv15" userUid component={Rutas} path="/dashboard/routes" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashRoutes} path="/dashboard/route/details/:id" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashRoutesEdit} path="/dashboard/route/:id/edit" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashRoutesNew} path="/dashboard/routes/new" exact/>
          <RutaPotegida keyid="serv15" userUid component={DashRoutesAdd} path="/dashboard/route/:id/dispatches" exact/>

          <RutaPotegida keyid="serv20" userUid component={Serviciosdash} path="/dashboard/servicios" exact/>
          <RutaPotegida keyid="serv20" userUid component={Seleccionepack} path="/dashboard/servicios/seleccione_pack" exact/>
          <RutaPotegida keyid="serv20" userUid component={Seleccioneplan} path="/dashboard/servicios/seleccione_plan" exact/>

          <RutaPotegida keyid="serv12" userUid component={Billing} path="/billing/" exact/>

          <RutaPotegida keyid="serv21" userUid component={Configuraciones} path="/dashboard/settings" exact/>
          <RutaPotegida keyid="serv22" userUid component={Seguridad} path="/dashboard/Seguridad" exact/>

          <RutaPotegida keyid="serv06" userUid component={ReportBug} path="/dashboard/report-bugs" exact/>
          <RutaPotegida keyid="serv23" userUid component={ReportBug} path="/dashboard/manager-bug" exact/>

          <RutaPotegida keyid="serv24" userUid component={ReportBug} path="/dashboard/manager-mensajes" exact/>
          <RutaPotegida keyid="serv25" userUid component={Soporte} path="/dashboard/manager-soporte" exact/>

          <RutaPotegida keyid="serv07" userUid component={Mensaje} path="/dashboard/mensaje" exact/>
          <RutaPotegida keyid="develop" userUid component={Soporte} path="/dashboard/soporte" exact/>

          <RutaPotegida keyid="serv08" userUid component={Companies} path="/dashboard/soporte" exact/>
     

       </Switch>
       </Grid.Column>
       </Grid.Row>
       </Grid.Column>
      </Grid.Row>
      </Grid>

      </div>
  );
  };

  export  default Dashboard;

